import { gql, useQuery } from "@apollo/client";
import { Alert, Form, Select } from "antd";
import { SelectOptionDetails } from "./SelectOptionDetails";

export const GET_GENIUS_RETAIL_ACCOUNT_DETAILS = gql`
  query GetGeniusRetailAccountDetails {
    geniusRetailAccountDetails(isActive: true) {
      AccountId
      AccountName
      PrimaryUserEmail
      IsActive
      MasterAccountId
      AgencyName
      LocationMIDs
    }
  }
`;

type GeniusRetailAccountDetails = {
  AccountId: number;
  AccountName: string;
  PrimaryUserEmail: string;
  IsActive: boolean;
  MasterAccountId: string;
  AgencyName: string;
  LocationMIDs: string;
};

export const GeniusRetailDestinationOptions = () => {
  const { data, loading, error } = useQuery<{
    geniusRetailAccountDetails: GeniusRetailAccountDetails[];
  }>(GET_GENIUS_RETAIL_ACCOUNT_DETAILS);

  return (
    <>
      {error && (
        <Alert
          message="Error fetching Genius Retail account details, please try again."
          type="error"
        />
      )}
      <Form.Item
        key="destinationAccountId"
        name="destinationAccountId"
        label="Account ID"
        rules={[{ required: true }]}
      >
        <Select
          showSearch
          loading={loading}
          placeholder="Search for an account Id"
          optionFilterProp="search"
          disabled={!!error}
          options={data?.geniusRetailAccountDetails.map((account) => ({
            ...account,
            search: [
              account.AccountId,
              account.AccountName,
              account.PrimaryUserEmail,
              account.MasterAccountId,
              account.LocationMIDs,
            ].join(" "),
            value: account.AccountId,
          }))}
          optionRender={({ data }) => (
            <SelectOptionDetails
              titleLabel="Account ID"
              titleKey="AccountId"
              fields={{
                Name: "AccountName",
                Email: "PrimaryUserEmail",
                "Master ID": "MasterAccountId",
                "Agency": "AgencyName",
                "MIDs": "LocationMIDs",
              }}
              data={data}
            />
          )}
        />
      </Form.Item>
    </>
  );
};
